$(document).ready(() => {
  $(document).on('change', '.state_input', (event) => {
    const federativeUnityId = $(event.currentTarget).val();
    const municipalities = $(`#${event.currentTarget.dataset.addressLookupTarget}`);

    $.ajax({
      url: '/br_territory/municipalities',
      type: 'get',
      data: { federative_unity_id: federativeUnityId },
      beforeSend() {
        municipalities.attr('disabled', 'disabled');
      },
      success(data) {
        municipalities.empty();
        const selectedMunicipality = municipalities.data('municipality-name');
        municipalities.html(data.map((item) => {
          if (typeof (selectedMunicipality) !== 'undefined' && selectedMunicipality === item.name) {
            return `<option value='${item.id}' selected>${item.name}</option>`;
          }
          return `<option value='${item.id}'>${item.name}</option>`;
        }));

        municipalities.removeAttr('disabled');
      },
      error(data) {
        municipalities.empty();

        municipalities.removeAttr('disabled');

        /* eslint-disable-next-line no-console */
        console.error('AJAX Error: ', JSON.stringify(data));
      },
    });
  });

  function attrsDisable(state, idPattern) {
    if (state === true) {
      $('.state_input').attr('disabled', 'disabled');
      $(`${idPattern}municipality`).attr('disabled', 'disabled');
      $(`${idPattern}street`).attr('disabled', 'disabled');
      $(`${idPattern}neighborhood`).attr('disabled', 'disabled');
      $(`${idPattern}complement`).attr('disabled', 'disabled');
    } else {
      $('.state_input').removeAttr('disabled');
      $(`${idPattern}municipality`).removeAttr('disabled');
      $(`${idPattern}street`).removeAttr('disabled');
      $(`${idPattern}neighborhood`).removeAttr('disabled');
      $(`${idPattern}complement`).removeAttr('disabled');
    }
  }

  $('.input--cep').on('blur', () => {
    const zipCode = $('.input--cep').val();
    const idPattern = `#${$('.input--cep').attr('id').replace('zip_code', '')}`;

    if (zipCode.length !== 9) {
      $('.state_input  option')
        .removeAttr('selected');
      $(`${idPattern}municipality`).data('municipality-name', '');
      $(`${idPattern}street`).val('');
      $(`${idPattern}neighborhood`).val('');
      $(`${idPattern}complement`).val('');

      return;
    }

    $.ajax({
      url: `/grafeno/zip_code/${zipCode}`,
      type: 'get',
      data: {},
      beforeSend() {
        attrsDisable(true, idPattern);
      },
      success(data) {
        $('.state_input  option')
          .removeAttr('selected')
          .filter(`[data-federative-unity-code=${data.data.state}]`)
          .attr('selected', true)
          .change();
        $(`${idPattern}municipality`).data('municipality-name', data.data.city);
        $(`${idPattern}street`).val(data.data.address);
        $(`${idPattern}neighborhood`).val(data.data.neighborhood);
        $(`${idPattern}complement`).val(data.data.complement);
        $(`${idPattern}number`).focus();

        attrsDisable(false, idPattern);
      },
      error(data) {
        attrsDisable(false, idPattern);

        /* eslint-disable-next-line no-console */
        console.error('AJAX Error: ', JSON.stringify(data));
      },
    });
  });
});
